<div ng-controller="ImportFolderController as importFolderCtrl" class="modal-view import-folder-view">
    <c-auto-form config="importFolderCtrl.autoFormConfig"></c-auto-form>
</div>
